import axios from 'axios';
import Cookies from 'js-cookie';
import {
  fetchWishlistStart,
  fetchWishlistSuccess,
  fetchWishlistFailure,
  addToWishlist,
  removeFromWishlist
} from '../slices/wishlistSlice';

export const fetchWishlist = () => async (dispatch) => {
  try {
    dispatch(fetchWishlistStart());
    const token = Cookies.get('ecom_user_token');
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-wishlist`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    // Store full wishlist items with products
    dispatch(fetchWishlistSuccess(response.data.wishlist || []));
  } catch (error) {
    dispatch(fetchWishlistFailure(error.message));
  }
};


// wishlistThunks.js
export const addItemToWishlist = (productId, variantId) => async (dispatch) => {
  try {
    const token = Cookies.get('ecom_user_token');
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/buyer/add-to-wishlist`,
      { productId, variantId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch(fetchWishlist()); // Refresh wishlist after addition
  } catch (error) {
    console.error('Error adding to wishlist:', error);
    throw error; // Re-throw to handle in component
  }
};


// wishlistThunks.js
export const removeItemFromWishlist = (productId, variantId) => async (dispatch) => {
  try {
    const token = Cookies.get('ecom_user_token');
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-from-wishlist/${productId}/variant/${variantId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch(removeFromWishlist({ productId, variantId }));
  } catch (error) {
    console.error('Error removing from wishlist:', error);
    throw error;
  }
};
// export const removeItemFromWishlist = (productId, variantId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.delete(
//       `${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-from-wishlist/${productId}`,
//       { 
//         headers: { Authorization: `Bearer ${token}` },
//         data: { variantId } // Send variantId in the request body for DELETE
//       }
//     );
//     dispatch(removeFromWishlist({ productId, variantId }));
//   } catch (error) {
//     console.error('Error removing from wishlist:', error);
//     throw error; // Re-throw to handle in component
//   }
// };

// export const addItemToWishlist = (productId,variantId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.post(
//       `${process.env.REACT_APP_BACKEND_URL}/api/buyer/add-to-wishlist`,
//       { productId,variantId },
//       { headers: { Authorization: `Bearer ${token}` } }
//     );
//     dispatch(fetchWishlist());  // Refresh wishlist after addition
//   } catch (error) {
//     console.error('Error adding to wishlist:', error);
//   }
// };

// export const removeItemFromWishlist = (productId, variantId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.delete(
//       `${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-from-wishlist/${productId}`,
//       { headers: { Authorization: `Bearer ${token}` } }
//     );
//     dispatch(removeFromWishlist(productId,variantId));
//   } catch (error) {
//     console.error('Error removing from wishlist:', error);
//   }
// };



// src/redux/thunks/wishlistThunks.js
// import axios from 'axios';
// import Cookies from 'js-cookie';
// import {
//   fetchWishlistStart,
//   fetchWishlistSuccess,
//   fetchWishlistFailure,
//   addToWishlist,
//   removeFromWishlist
// } from '../slices/wishlistSlice';

// export const fetchWishlist = () => async (dispatch) => {
//   try {
//     dispatch(fetchWishlistStart());
//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-wishlist',
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
    
//     // Store full wishlist items with products
//     dispatch(fetchWishlistSuccess(response.data.wishlist || []));
//   } catch (error) {
//     dispatch(fetchWishlistFailure(error.message));
  
//   }
// };

// export const fetchWishlist = () => async (dispatch) => {
//   try {
//     dispatch(fetchWishlistStart());
//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-wishlist',
//       { headers: { Authorization: `Bearer ${token}` } }
//     );
    
//     // Explicitly handle empty response
//     const wishlistItems = response.data.wishlist || [];
//     dispatch(fetchWishlistSuccess(wishlistItems));
//   } catch (error) {
//     dispatch(fetchWishlistFailure(error.message));
//   }
// };

// export const addItemToWishlist = (productId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.post(
//       'https://seller-backend-29o9.onrender.com/api/buyer/add-to-wishlist',
//       { productId },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
    
//     // Add the full wishlist item
//     const addedItem = response.data.wishlistItem;
//     dispatch(addToWishlist(addedItem));
//   } catch (error) {
//     console.error('Error adding to wishlist:', error);
//   }
// };

// export const addItemToWishlist = (productId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.post(
//       'https://seller-backend-29o9.onrender.com/api/buyer/add-to-wishlist',
//       { productId },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     // Fetch updated wishlist after successful addition
//     dispatch(fetchWishlist());
//   } catch (error) {
//     console.error('Error adding to wishlist:', error);
//   }
// };


// export const removeItemFromWishlist = (productId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.delete(
//       `https://seller-backend-29o9.onrender.com/api/buyer/remove-from-wishlist/${productId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         }
//       }
//     );
//     dispatch(removeFromWishlist(productId));
//   } catch (error) {
//     console.error('Error removing from wishlist:', error);
//   }
// };

// // src/redux/thunks/wishlistThunks.js
// import axios from 'axios';
// import Cookies from 'js-cookie';
// import {
//   fetchWishlistStart,
//   fetchWishlistSuccess,
//   fetchWishlistFailure,
//   addToWishlist,
//   removeFromWishlist
// } from '../slices/wishlistSlice';

// export const fetchWishlist = () => async (dispatch) => {
//   try {
//     dispatch(fetchWishlistStart());
//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-wishlist',
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
    
//     // Extract only the required fields from each wishlist item
//     const simplifiedWishlist = response.data.wishlist.map(item => ({
//       _id: item?._id,
//       addedDate: item?.addedDate,
//       productId: item?.productId?._id
//     }));
    
//     dispatch(fetchWishlistSuccess(simplifiedWishlist || []));
//   } catch (error) {
//     dispatch(fetchWishlistFailure(error.message));
//   }
// };

// export const addItemToWishlist = (productId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.post(
//       'https://seller-backend-29o9.onrender.com/api/buyer/add-to-wishlist',
//       { productId },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//        // Get the last item from the wishlist array
//     const lastWishlistItem = response.data.wishlist[response.data.wishlist.length - 1];
    
//     // Dispatch only the last item (assuming your reducer can handle the object structure)
//     dispatch(addToWishlist(lastWishlistItem));    
//     // // If API returns { product: { ... } }
//     // dispatch(addToWishlist(response.data.wishlist));
    
//     // If API returns { productId: { ... } (same as get-wishlist)
//     // dispatch(addToWishlist(response.data.productId));
//   } catch (error) {
//     console.error('Error adding to wishlist:', error);
//   }
// };
// export const removeItemFromWishlist = (productId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.delete(
//       `https://seller-backend-29o9.onrender.com/api/buyer/remove-from-wishlist/${productId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         }
//       }
//     );
//     dispatch(removeFromWishlist(productId));
//   } catch (error) {
//     console.error('Error removing from wishlist:', error);
//   }
// };